import {Component, Vue} from 'vue-property-decorator';
import GamesFilter from '@/components/GamesFilter/index.vue';
import {Getter} from 'vuex-class';
import {GameInterface} from '@/store/modules/games/types';

@Component({
    name: 'v-reported-issues-game-select',
    components: {
        'c-games-filter': GamesFilter,
    },
})

export default class ReportedIssuesGameSelect extends Vue {

    // Games
    @Getter('getCurrentGame', {namespace: 'gamesStateModule'})
    public getCurrentGame!: GameInterface;

}
